import { TypographyH3 } from "@/components/typography/H3";
import { TypographyP } from "@/components/typography/P";
import { ReactNode } from "react";

type Props = {
  header: string;
  subHeader?: string;
  children?: ReactNode;
};

export const PageHeader = ({ header, subHeader, children }: Props) => {
  return (
    <div className="flex items-center justify-between w-full mb-4">
      <div>
        <TypographyH3 className="dark:text-brand-gray-50 text-brand-gray-800 mb-1">
          {header}
        </TypographyH3>
        {subHeader && (
          <TypographyP data-testid="pageSubheader">{subHeader}</TypographyP>
        )}
      </div>
      {children}
    </div>
  );
};
